import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

const KEY = "felise_cookie_ok";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 1800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "1");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-5 left-5 right-5 md:left-auto md:right-8 md:max-w-md z-[80] border border-white/10 bg-[#121214]/95 backdrop-blur-xl p-6"
          data-testid="cookie-banner"
        >
          <p className="text-sm text-muted-foreground leading-relaxed">
            Usiamo solo <span className="text-foreground">cookie tecnici</span> per il
            funzionamento del sito e la sicurezza del pagamento. Nessun tracciamento
            pubblicitario.{" "}
            <Link to="/cookie-policy" className="text-primary underline underline-offset-4" data-testid="cookie-banner-link">
              Dettagli
            </Link>
          </p>
          <div className="mt-5 flex gap-3">
            <button
              onClick={accept}
              data-testid="cookie-banner-accept"
              className="h-11 px-7 rounded-full bg-primary text-primary-foreground text-xs uppercase tracking-[0.2em] font-medium hover:bg-[#c8ad8f] transition-colors duration-300"
            >
              Accetta
            </button>
            <button
              onClick={accept}
              data-testid="cookie-banner-reject"
              className="h-11 px-7 rounded-full border border-white/20 text-xs uppercase tracking-[0.2em] text-muted-foreground hover:border-primary hover:text-primary transition-colors duration-300"
            >
              Rifiuta
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
